import { render, staticRenderFns } from "./ObjectionDialog.vue?vue&type=template&id=2471e680&"
import script from "./ObjectionDialog.vue?vue&type=script&lang=js&"
export * from "./ObjectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2471e680')) {
      api.createRecord('2471e680', component.options)
    } else {
      api.reload('2471e680', component.options)
    }
    module.hot.accept("./ObjectionDialog.vue?vue&type=template&id=2471e680&", function () {
      api.rerender('2471e680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/components/ObjectionDialog.vue"
export default component.exports